"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindingEvent = void 0;
var evetnbus_concrete_1 = require("../event/evetnbus-concrete");
var encrypt_deccrypt_1 = require("./encrypt_deccrypt");
var form_validation_1 = require("./form_validation");
var util_1 = require("../common/util");
var eval_1 = require("../services/eval");
var dom_parsing_1 = require("./dom_parsing");
var BindingEvent = (function () {
    function BindingEvent(config) {
        this.config = config;
        this.domParsing = new dom_parsing_1.DomParsing();
        this.evalService = new eval_1.EvalService();
        this.encryptAndDecrypt = new encrypt_deccrypt_1.EncryptAndDecrypt(this.config);
        this.formValidation = new form_validation_1.FormValidation(this.config);
        this.eventbus = evetnbus_concrete_1.EventBusConcrete.getInstance();
        this.eventListnersList = [];
        this.returnHTMLOnError = false;
    }
    BindingEvent.prototype.init = function (serviceCallResponseData, callback, itgInstance) {
        var _this = this;
        if (this.eventListnersList.length) {
            this.eventListnersList.forEach(function (listnerDetail) {
                if (listnerDetail.element) {
                    listnerDetail.element.removeEventListener(listnerDetail.event, listnerDetail.handlerFunction);
                }
            });
            this.eventListnersList = [];
        }
        var filterInputElements = document.querySelectorAll('[rsInputFilter]');
        if (filterInputElements && filterInputElements.length) {
            filterInputElements.forEach(function (rsInputFilter) {
                if (rsInputFilter.getAttribute(util_1.Constants.RS_INPUT_FILTER)) {
                    _this.rsInputFilterHandling(rsInputFilter);
                }
            });
        }
        var modelElements = document.querySelectorAll('[rsMonitor]');
        if (modelElements && modelElements.length) {
            modelElements.forEach(function (rsmodel) {
                if (rsmodel.getAttribute(util_1.Constants.RS_MONITOR)) {
                    _this.rsModelHandling(rsmodel);
                }
            });
        }
        var formELements = document.querySelectorAll('[rsActionOriginator]');
        this.serviceCallResponseData = serviceCallResponseData;
        if (formELements && formELements.length) {
            this.formValidation.allFormRules = {};
            formELements.forEach(function (formElement) {
                _this.formValidation.init(formElement, _this.serviceCallResponseData);
            });
        }
        var formSubmitEvent = function () {
            _this.formSubmitEvent(callback, itgInstance);
        };
        var submitElements = document.querySelectorAll('[rsSubmit]');
        if (submitElements && submitElements.length) {
            submitElements.forEach(function (submitElement) {
                var _a;
                var submitAttr = submitElement.getAttribute('rsSubmit');
                var eventType = (_a = submitElement.getAttribute('rsSubmitEventType')) === null || _a === void 0 ? void 0 : _a.toString();
                if (!eventType) {
                    eventType = 'click';
                }
                if (submitAttr === 'true') {
                    submitElement.addEventListener(eventType, formSubmitEvent);
                    _this.eventListnersList.push({
                        element: submitElement,
                        event: eventType,
                        handlerFunction: formSubmitEvent,
                    });
                }
            });
        }
    };
    BindingEvent.prototype.setInputFilter = function (textbox, inputFilter) {
        var filterFunc = function () {
            if (inputFilter(textbox.value)) {
                textbox.oldValue = textbox.value;
                textbox.oldSelectionStart = textbox.selectionStart;
                textbox.oldSelectionEnd = textbox.selectionEnd;
            }
            else if (textbox.hasOwnProperty('oldValue')) {
                textbox.value = textbox.oldValue;
                textbox.setSelectionRange(textbox.oldSelectionStart, textbox.oldSelectionEnd);
            }
            else {
                textbox.value = '';
            }
        };
        var self = this;
        ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
            textbox.addEventListener(event, filterFunc);
            self.eventListnersList.push({
                element: textbox,
                event: event,
                handlerFunction: filterFunc,
            });
        });
    };
    BindingEvent.prototype.setModelVallue = function (textbox, inputFilter, isFirstCall) {
        var inputVal = [];
        if (textbox.tagName === 'SELECT') {
            var selectedOptions = [];
            var selectElement = textbox;
            if (selectElement) {
                selectedOptions = Array.from(selectElement.options)
                    .filter(function (option) {
                    return option.selected;
                })
                    .map(function (option) {
                    return option.value;
                });
            }
            inputVal = selectedOptions.length > 0 ? selectedOptions : [];
        }
        else if (textbox.tagName === 'INPUT' || textbox.tagName === 'BUTTON') {
            var type = textbox.getAttribute('type');
            var inputElement = textbox;
            switch (type) {
                case 'radio':
                case 'checkbox':
                    var name_1 = inputElement.getAttribute('name');
                    var radio = document.getElementsByName("" + name_1);
                    var selectedValues = Array.from(radio)
                        .filter(function (option) {
                        return option.checked;
                    })
                        .map(function (option) {
                        return option.value;
                    });
                    inputVal = selectedValues.length > 0 ? selectedValues : [];
                    break;
                default:
                    if (isFirstCall && textbox.tagName === 'BUTTON') {
                        inputVal = '';
                    }
                    else {
                        inputVal = inputElement.value ? inputElement.value : '';
                    }
                    break;
            }
        }
        else {
            var inputElement = textbox;
            inputVal = inputElement.value ? inputElement.value : '';
        }
        inputFilter(inputVal, textbox);
    };
    BindingEvent.prototype.setModel = function (textbox, inputFilter) {
        var _this = this;
        var _a;
        var eventType = (_a = textbox.getAttribute('rsDataBindingEventType')) === null || _a === void 0 ? void 0 : _a.toString();
        if (!eventType) {
            eventType = 'change';
        }
        this.setModelVallue(textbox, inputFilter, true);
        textbox.addEventListener(eventType, function () {
            _this.setModelVallue(textbox, inputFilter);
        });
    };
    BindingEvent.prototype.rsModelHandling = function (content) {
        var _this = this;
        var element = content;
        var modelKey = content.getAttribute(util_1.Constants.RS_MONITOR);
        if (element && modelKey) {
            this.setModel(element, function (value, srcElement) {
                var bindinngElement = document.querySelectorAll('[data-binding]');
                if (bindinngElement && bindinngElement.length) {
                    bindinngElement.forEach(function (databindingAttr) {
                        var databinding = databindingAttr.getAttribute('data-binding');
                        var databindingType = databindingAttr.getAttribute('data-binding-type');
                        var AttrName = databindingAttr.getAttribute('data-binding-attr');
                        var readFromAttr = true;
                        if (value === '') {
                            readFromAttr = false;
                        }
                        if (value && value.length === 0) {
                            readFromAttr = false;
                        }
                        var updatedkey = databinding.trim().split('[').join('.').split(']').join('');
                        var valueData = '';
                        if (modelKey && databinding && databinding.indexOf(modelKey.trim()) > -1) {
                            updatedkey = updatedkey.replace(modelKey.trim(), 'model');
                            if (updatedkey.indexOf("model.") === -1) {
                                updatedkey = updatedkey.replace('model', 'model.');
                            }
                            if (readFromAttr && AttrName) {
                                value = srcElement.getAttribute(AttrName);
                            }
                            if (value !== null || value !== undefined) {
                                valueData = _this.evalService.parseString(updatedkey, value);
                            }
                            if (databindingType) {
                                if (databindingType.trim() === 'html' || databindingType.trim() === 'value') {
                                    if (databindingAttr.tagName === 'INPUT' ||
                                        databindingAttr.tagName === 'SELECT' ||
                                        databindingAttr.tagName === 'BUTTON') {
                                        var type = databindingAttr.type;
                                        switch (type) {
                                            case 'radio':
                                            case 'checkbox':
                                                var name_2 = databindingAttr.getAttribute('name');
                                                var radio = document.getElementsByName("" + name_2);
                                                for (var i = 0; i < radio.length; i++) {
                                                    radio[i].checked = valueData && valueData.indexOf(databindingAttr.options[i].value) >= 0;
                                                }
                                                break;
                                            case 'select-multiple':
                                                for (var i = 0; i < databindingAttr.options.length; i++) {
                                                    databindingAttr.options[i].selected =
                                                        valueData && valueData.indexOf(databindingAttr.options[i].value) >= 0;
                                                }
                                                break;
                                            default:
                                                databindingAttr.value = valueData;
                                        }
                                    }
                                    else {
                                        databindingAttr.innerHTML = valueData;
                                    }
                                }
                                else if (databindingType.trim() === 'template') {
                                    var rsTemplateName = databindingAttr.getAttribute('rsTempalteName') || databindingAttr.getAttribute('rsTemplateName');
                                    if (databindingAttr && rsTemplateName) {
                                        databindingAttr.setAttribute('rsNestedTemplateData', rsTemplateName + 'Data');
                                        var data = {};
                                        data['' + databindingAttr.getAttribute('rsNestedTemplateData')] = valueData;
                                        _this.domParsing.parseNested(databindingAttr, data, dom_parsing_1.DomParsing.templatesArray['' + rsTemplateName], true);
                                        databindingAttr.innerHTML = _this.evalService.parseTpl(databindingAttr.innerHTML, data);
                                    }
                                }
                                else if (databindingType.trim() === 'class') {
                                    if (databindingAttr.dataset && databindingAttr.dataset['classListArray']) {
                                        databindingAttr.classList = databindingAttr.dataset['classListArray'];
                                    }
                                    else {
                                        databindingAttr.dataset['classListArray'] = databindingAttr.classList;
                                    }
                                    databindingAttr.className += ' ' + valueData;
                                }
                                else {
                                    databindingAttr.setAttribute(databindingType.trim(), valueData);
                                }
                            }
                        }
                    });
                }
            });
        }
    };
    BindingEvent.prototype.rsInputFilterHandling = function (content) {
        var element = content;
        var filterRegexStr = content.getAttribute(util_1.Constants.RS_INPUT_FILTER);
        if (filterRegexStr && filterRegexStr !== 'undefined' && filterRegexStr !== 'null') {
            var filterRegex_1 = new RegExp(filterRegexStr);
            this.setInputFilter(element, function (value) {
                return filterRegex_1.test(value);
            });
        }
    };
    BindingEvent.prototype.formSubmitEvent = function (callback, itgInstance) {
        var _this = this;
        var hasMultipleValue = false;
        var eventData = event;
        var finalData = Object.assign({
            formName: eventData,
        });
        var targetElementList = [];
        var formELements = document.querySelectorAll('[rsActionOriginator]');
        if (formELements && formELements.length) {
            formELements.forEach(function (formElement) {
                var formAttr = formElement.getAttribute('rsActionOriginator');
                if (formAttr) {
                    finalData[formAttr] = Object.assign({});
                    var formKeyElements = formElement.querySelectorAll('rsActionOriginatorKey');
                    if (formKeyElements && formKeyElements.length) {
                        formKeyElements.forEach(function (keyElement) {
                            var formKey = keyElement.getAttribute('rsActionOriginatorKey');
                            if (formKey) {
                                finalData[formAttr].displayFormReferenceKey = formKey;
                            }
                        });
                    }
                    var submitElements = formElement.querySelectorAll('[rsMonitor]');
                    if (submitElements && submitElements.length) {
                        submitElements.forEach(function (element) {
                            var _a, _b, _c, _d;
                            var inputVal = null;
                            var monitorAttr = element.getAttribute('rsMonitor');
                            if (monitorAttr) {
                                if (element.tagName === 'SELECT') {
                                    var selectedOptions = [];
                                    var selectElement = element;
                                    if (selectElement) {
                                        selectedOptions = Array.from(selectElement.options)
                                            .filter(function (option) {
                                            if (option.value) {
                                                return option.selected;
                                            }
                                        })
                                            .map(function (option) {
                                            if (option.value) {
                                                return option.value;
                                            }
                                        });
                                    }
                                    inputVal = selectedOptions.length > 0 ? selectedOptions : null;
                                }
                                else if (element.tagName === 'INPUT') {
                                    var type = element.getAttribute('type');
                                    var inputElement = element;
                                    switch (type) {
                                        case 'text':
                                            inputVal = ((_a = inputElement.value) === null || _a === void 0 ? void 0 : _a.trim()) ? inputElement.value.trim() : null;
                                            break;
                                        case 'password':
                                            if (((_c = (_b = inputElement.value) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                                                var encVal = _this.encryptAndDecrypt.enCryptDeCryptValue((_d = inputElement.value) === null || _d === void 0 ? void 0 : _d.trim(), _this.serviceCallResponseData.sessionId, true);
                                                inputVal = '{cipher}' + encVal;
                                            }
                                            break;
                                        case 'radio':
                                        case 'checkbox':
                                            var name_3 = inputElement.getAttribute('name');
                                            var radio = document.getElementsByName("" + name_3);
                                            var selectedValues = Array.from(radio)
                                                .filter(function (option) {
                                                return option.checked;
                                            })
                                                .map(function (option) {
                                                return option.value;
                                            });
                                            if (JSON.stringify(finalData[formAttr][monitorAttr]) !== JSON.stringify(selectedValues)) {
                                                inputVal = selectedValues.length > 0 ? selectedValues : null;
                                            }
                                            break;
                                        default:
                                            inputVal = inputElement.value ? inputElement.value : null;
                                            break;
                                    }
                                }
                                else if (element.tagName === 'TEXTAREA') {
                                    var inputElement = element;
                                    inputVal = inputElement.value ? inputElement.value : null;
                                }
                                else {
                                    if (element.tagName !== 'BUTTON') {
                                        var customElement = element;
                                        inputVal = customElement.value ? customElement.value : null;
                                    }
                                }
                                if (finalData[formAttr][monitorAttr] && finalData[formAttr][monitorAttr] !== undefined && inputVal) {
                                    hasMultipleValue = true;
                                    var result = [];
                                    result[monitorAttr] = 'Control have multiple values';
                                    _this.formValidation.updateFormErrorHtml(result, eventData.target.getAttribute('rsactionoriginatorkey'));
                                    console.log('multiple value pass issue');
                                    return;
                                }
                                if (finalData[formAttr][monitorAttr] === undefined) {
                                    var rulesElement = _this.formValidation.rulesForElement(element);
                                    _this.formValidation.updateRules(monitorAttr, formAttr, rulesElement);
                                    finalData[formAttr][monitorAttr] = inputVal;
                                    targetElementList[monitorAttr] = element;
                                }
                                if (finalData[formAttr][monitorAttr] === null && inputVal) {
                                    var rulesElement = _this.formValidation.rulesForElement(element);
                                    _this.formValidation.updateRules(monitorAttr, formAttr, rulesElement);
                                    finalData[formAttr][monitorAttr] = inputVal;
                                    targetElementList[monitorAttr] = element;
                                }
                            }
                            else {
                                console.log('rsMonitor error', 'check json reponse that control must have some value in variable key for element', element);
                            }
                        });
                    }
                }
            });
            if (eventData.target.getAttribute('rsmonitor')) {
                var rulesElement = this.formValidation.rulesForElement(eventData.target);
                this.formValidation.updateRules(eventData.target.getAttribute('rsmonitor'), eventData.target.getAttribute('rsactionoriginatorkey'), rulesElement);
                if (eventData.target.tagName === 'BUTTON') {
                    finalData[eventData.target.getAttribute('rsactionoriginatorkey')][eventData.target.getAttribute('rsmonitor')] = eventData.target.value;
                }
                targetElementList[eventData.target.getAttribute('rsmonitor')] = eventData.target;
            }
        }
        if (!hasMultipleValue) {
            if (eventData.target.getAttribute('rsHtmlOnError') === 'true') {
                this.returnHTMLOnError = true;
            }
            else {
                this.returnHTMLOnError = false;
            }
            if (eventData.target.getAttribute('rsvalidate') === 'true' ||
                (eventData.target.getAttribute('rsvalidate') && eventData.target.getAttribute('rsvalidate') !== 'false')) {
                var formValid = this.formValidation.validateForm(finalData[finalData.formName.target.getAttribute('rsactionoriginatorkey')], finalData.formName.target.getAttribute('rsactionoriginatorkey'), targetElementList);
                if (formValid) {
                    if (itgInstance) {
                        callback.call(itgInstance, finalData, this);
                    }
                    else {
                        callback(finalData, this);
                    }
                }
                else {
                    console.log('Form is not valid');
                }
            }
            else {
                if (itgInstance) {
                    callback.call(itgInstance, finalData, this);
                }
                else {
                    callback(finalData, this);
                }
            }
        }
    };
    return BindingEvent;
}());
exports.BindingEvent = BindingEvent;
//# sourceMappingURL=binding_event.js.map